
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class CollapsibleDescription extends Vue {
    @Prop({ type: String, default: undefined }) readonly description!: string;
    @Prop({ type: Number, default: 100 }) readonly descriptionMaxLength!: number;

    expanded: boolean = false;

    get descriptionParagraphs(): string[] {
      return this.shownDescription.split("\n");
    }

    get expandButtonText(): string {
      return this.expanded ? "collapse" : "expand";
    }

    toggleExpandDescription(): void {
      this.expanded = !this.expanded;
    }

    get shownDescription(): string {
      if (!this.shouldDescriptionBeShortened) {
        return this.description;
      }

      if (this.expanded) {
        return this.description;
      }

      return this.shortDescription(this.description);
    }

    get shouldDescriptionBeShortened(): boolean {
      return this.description.length > this.descriptionMaxLength;
    }

    shortDescription(description: string): string {
      const maxLengthDescription = description.substr(0, this.descriptionMaxLength);
      const truncatedToLastSpace = maxLengthDescription.substr(0, maxLengthDescription.lastIndexOf(" "));
      return `${truncatedToLastSpace}...`;
    }

    getParagraphClasses(index: number) {
      return {
        "inline": index + 1 === this.descriptionParagraphs.length,
      };
    }
  }
